export default __webpack_public_path__ + "static/media/anish-khatu.26bd6a72.jpeg";